// extracted by mini-css-extract-plugin
export default {"outerDiv":"CarouselUtil_outerDiv__74dL9","innerDiv":"CarouselUtil_innerDiv__9k6ny"};